import React, { useState } from 'react';
import './AuthForm.css';

function AuthForm({ onAuthSuccess }) {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    avatarName: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError(''); // Clear error when user types
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Validation
    if (!formData.username.trim() || !formData.password.trim()) {
      setError('Nom d\'utilisateur et mot de passe requis');
      setLoading(false);
      return;
    }

    if (formData.username.length < 3) {
      setError('Le nom d\'utilisateur doit contenir au moins 3 caractères');
      setLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('Le mot de passe doit contenir au moins 6 caractères');
      setLoading(false);
      return;
    }

    try {
      const endpoint = isLogin ? 'https://server.bibleforce.com/api/login' : 'https://server.bibleforce.com/api/register';
      const payload = isLogin 
        ? { username: formData.username, password: formData.password }
        : formData;

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (response.ok) {
        // Store token and user data
        localStorage.setItem('spiritToken', data.token);
        localStorage.setItem('spiritUser', JSON.stringify(data.user));
        onAuthSuccess(data.token, data.user);
      } else {
        setError(data.error || 'Erreur d\'authentification');
      }
    } catch (err) {
      setError('Erreur de connexion au serveur');
    }

    setLoading(false);
  };

  const toggleMode = () => {
    setIsLogin(!isLogin);
    setError('');
    setFormData({ username: '', password: '', avatarName: '' });
  };

  return (
    <div className="auth-container">
      <div className="auth-background">
        <div className="auth-halo" />
        <div className="auth-cross">✝</div>
      </div>
      
      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="auth-header">
          <h1>Saint-Esprit Avatar</h1>
          <p className="auth-subtitle">© 2026 BibleForce</p>
          <h2>{isLogin ? 'Connexion' : 'Créer un compte'}</h2>
        </div>

        {error && <div className="auth-error">{error}</div>}

        <div className="auth-field">
          <label htmlFor="username">Nom d'utilisateur</label>
          <input
            type="text"
            id="username"
            name="username"
            value={formData.username}
            onChange={handleInputChange}
            placeholder="Ex: jean_paul"
            maxLength={30}
            disabled={loading}
            autoComplete="username"
          />
        </div>

        <div className="auth-field">
          <label htmlFor="password">Mot de passe</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleInputChange}
            placeholder="6 caractères minimum"
            disabled={loading}
            autoComplete={isLogin ? "current-password" : "new-password"}
          />
        </div>

        {!isLogin && (
          <div className="auth-field">
            <label htmlFor="avatarName">Nom de votre avatar</label>
            <input
              type="text"
              id="avatarName"
              name="avatarName"
              value={formData.avatarName}
              onChange={handleInputChange}
              placeholder="Ex: Jean-Paul"
              maxLength={30}
              disabled={loading}
            />
          </div>
        )}

        <button 
          type="submit" 
          className="auth-submit"
          disabled={loading}
        >
          {loading ? (
            <span className="auth-loader">⏳ {isLogin ? 'Connexion...' : 'Création...'}</span>
          ) : (
            isLogin ? '🔑 Se connecter' : '✨ Créer mon compte'
          )}
        </button>

        <button
          type="button"
          className="auth-toggle"
          onClick={toggleMode}
          disabled={loading}
        >
          {isLogin ? "Pas encore de compte ? Créer un compte" : "Déjà un compte ? Se connecter"}
        </button>

        <div className="auth-info">
          <p>🔒 Vos données spirituelles sont sécurisées et privées</p>
        </div>
      </form>
    </div>
  );
}

export default AuthForm;